module.exports = __webpack_public_path__ + "img/linkedin-promo.fc1657ea.webp";